import React, { useState } from 'react';
import { orderApi } from '../../../lib/orderApi';
import { redButton } from '../../PageShell';
import { cfgInput, parseTags, uploadProductImage } from './productUtils';

const EMPTY = { name_es: '', price: '', tax_pct: '', category_es: 'Otros', image: '', description_es: '', tags: '', discount_pct: '' };

export const NewProductForm = ({ onCreated, setMsg }) => {
  const [newProd, setNewProd] = useState(EMPTY);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    setMsg('');
    try {
      const url = await uploadProductImage(file);
      setNewProd((p) => ({ ...p, image: url }));
      setMsg('✓ Imagen subida.');
    } catch (e) {
      setMsg('Error al subir imagen: ' + (e.response?.data?.detail || ''));
    } finally {
      setUploading(false);
    }
  };

  const createProduct = async () => {
    if (!newProd.name_es || newProd.price === '') {
      setMsg('Nombre y precio son obligatorios.');
      return;
    }
    try {
      await orderApi.post('/admin/products', {
        name_es: newProd.name_es,
        price: Number(newProd.price),
        tax_rate: Number(newProd.tax_pct || 0) / 100,
        category_es: newProd.category_es || 'Otros',
        image: newProd.image,
        description_es: newProd.description_es,
        tags: parseTags(newProd.tags),
        discount_pct: Math.min(90, Math.max(0, Number(newProd.discount_pct || 0))),
      });
      setNewProd(EMPTY);
      setMsg('✓ Producto agregado.');
      onCreated();
    } catch (e) {
      setMsg('Error: ' + (e.response?.data?.detail || ''));
    }
  };

  return (
    <div className="mt-5 p-4" style={{ background: '#0A0A0A', border: '1px dashed rgba(201,168,76,0.3)' }}>
      <p className="font-body uppercase" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C9A84C' }}>Agregar producto</p>
      <div className="flex flex-wrap gap-2 mt-2">
        <input
          placeholder="Nombre"
          value={newProd.name_es}
          onChange={(e) => setNewProd({ ...newProd, name_es: e.target.value })}
          style={{ ...cfgInput, width: '180px' }}
          data-testid="newprod-name"
        />
        <input
          type="number"
          step="0.01"
          placeholder="Precio"
          value={newProd.price}
          onChange={(e) => setNewProd({ ...newProd, price: e.target.value })}
          style={{ ...cfgInput, width: '100px' }}
          data-testid="newprod-price"
        />
        <input
          type="number"
          step="0.1"
          placeholder="Tax %"
          value={newProd.tax_pct}
          onChange={(e) => setNewProd({ ...newProd, tax_pct: e.target.value })}
          style={{ ...cfgInput, width: '90px' }}
          data-testid="newprod-tax"
        />
        <input
          placeholder="Categoría"
          value={newProd.category_es}
          onChange={(e) => setNewProd({ ...newProd, category_es: e.target.value })}
          style={{ ...cfgInput, width: '140px' }}
          data-testid="newprod-cat"
        />
        <input
          placeholder="URL de imagen (opcional)"
          value={newProd.image}
          onChange={(e) => setNewProd({ ...newProd, image: e.target.value })}
          style={{ ...cfgInput, width: '220px' }}
          data-testid="newprod-image"
        />
        <span>
          <input type="file" accept="image/*" id="newprod-file" style={{ display: 'none' }} onChange={(e) => upload(e.target.files[0])} data-testid="newprod-image-file" />
          <label htmlFor="newprod-file" className="font-body" style={{ color: '#C9A84C', border: '1px solid rgba(201,168,76,0.4)', padding: '9px 12px', fontSize: '12px', cursor: 'pointer', display: 'inline-block' }}>
            {uploading ? 'Subiendo…' : '📷 Subir foto'}
          </label>
        </span>
        <input
          type="number"
          min="0"
          max="90"
          step="0.5"
          placeholder="Desc %"
          value={newProd.discount_pct}
          onChange={(e) => setNewProd({ ...newProd, discount_pct: e.target.value })}
          style={{ ...cfgInput, width: '90px' }}
          data-testid="newprod-discount"
        />
        <input
          placeholder="Descripción (opcional)"
          value={newProd.description_es}
          onChange={(e) => setNewProd({ ...newProd, description_es: e.target.value })}
          style={{ ...cfgInput, width: '260px' }}
          data-testid="newprod-description"
        />
        <input
          placeholder="Tags: Nuevo, Picante (opcional)"
          value={newProd.tags}
          onChange={(e) => setNewProd({ ...newProd, tags: e.target.value })}
          style={{ ...cfgInput, width: '220px' }}
          data-testid="newprod-tags"
        />
        <button onClick={createProduct} style={redButton} data-testid="newprod-add">
          Agregar
        </button>
      </div>
    </div>
  );
};
